import React from "react";

import { Can } from "./AbilityContext";
import AccessDeniedSubscriptionPlan from "pages/AccessDeniedPageSubscriptionPlan";

const ProtectedRoute = ({ I, a, children }) => {
  return (
    <Can I={I} a={a} passThrough>
      {(allowed) => {
        return allowed ? children : <AccessDeniedSubscriptionPlan />;
      }}
    </Can>
  );
};

export default ProtectedRoute;
